// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"8cbb4303","525":"6c42808c","642":"8e25cb73","675":"36873e73","774":"aea9f7e8","884":"730c6436"}[chunkId] + ".chunk.js";
};